import React from "react";
export const Document = () => (
  <svg viewBox="0 0 14 16">
    <path d="M1 4c-.37 0-.67.3-.67.67v8.67c0 .73.6 1.33 1.33 1.33h8.67a.67.67 0 000-1.34h-8a.67.67 0 01-.67-.67v-8A.653.653 0 001 4zm11.33-2.67h-8C3.6 1.33 3 1.93 3 2.67v8C3 11.4 3.6 12 4.33 12h8c.73 0 1.33-.6 1.33-1.33v-8c.01-.74-.59-1.34-1.33-1.34zm-1.33 6H5.67c-.37 0-.67-.3-.67-.66S5.3 6 5.67 6H11c.37 0 .67.3.67.67s-.3.66-.67.66zM8.33 10H5.67a.67.67 0 010-1.34h2.67c.36.01.66.31.66.67s-.3.67-.67.67zM11 4.67H5.67a.67.67 0 010-1.34H11a.67.67 0 010 1.34z" />
  </svg>
);
